<template>
  <ServiceListPage />
</template>

<script>
import ServiceListPage from '@modules/service-catalog/views/list'
export default {
  name: 'ServiceList',
  components: { ServiceListPage },
}
</script>
